import React, {useEffect, useState} from 'react';
import {AdSlot} from 'app/components/ads/AdSlot';
import styled from 'styled-components';
import {adMaxSkyscraperWidth, defaultSpace, desktopContentWidth} from 'app/styles/media';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';

const maxHeightSuperbannerWithMargin = 250 + 32;
const defaultAppBarHeight = 72;
const tabBarHeight = 42;

const SCAdSlot = styled(AdSlot)`
  &&& {
    display: none;
    ${props =>
      props.theme.desktopLayoutWithHalfSky`
        display: ${props.left ? 'flex' : 'block'};
        ${props.left ? 'justify-content: flex-end;' : ''};
        background-color: transparent;
        min-width: ${props.left ? '300px' : '150px'};
        min-height: 600px;
        position: ${props.sticky ? 'fixed' : 'absolute'};
        margin-left: ${props.marginLeft};
        top: ${props.conditionalTopValue}px;
        margin-top: ${props.conditionalMarginTop}px;
        align-items: start;
        width: auto;
        height: auto;
        overflow: visible;
    `}
  }
`;

const selectSkipSkyscraper = createSelector(
  state => state.skyscraper,
  (_, skyScraperOnly) => skyScraperOnly,
  (skyscraper, skyScraperOnly) => {
    if (skyScraperOnly) {
      return false;
    } else {
      return skyscraper;
    }
  }
);

const getHeaderHeight = (passedAppBarHeight, withoutTabBar) => {
  const appBarHeight = passedAppBarHeight ?? defaultAppBarHeight;
  return withoutTabBar ? appBarHeight : appBarHeight + tabBarHeight;
};

const SkyscraperAdSlot = ({initPosition, left, noTabs, skyscraperOnly, stickyThreshold, ...props}) => {
  const skipSky = useSelector(state => selectSkipSkyscraper(state, skyscraperOnly));
  const [isSticky, setIsSticky] = useState(skyscraperOnly && !initPosition);

  useEffect(() => {
    const handleScroll = () => {
      const headerHeight = getHeaderHeight(initPosition, noTabs);
      if (!skyscraperOnly) {
        setIsSticky(window.scrollY >= maxHeightSuperbannerWithMargin);
      } else if (stickyThreshold) {
        setIsSticky(window.scrollY >= headerHeight - stickyThreshold);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [skyscraperOnly, stickyThreshold, noTabs, initPosition]);

  const headerHeight = getHeaderHeight(initPosition, noTabs);
  const conditionalTopValueInit = stickyThreshold ? stickyThreshold : headerHeight;
  const conditionalTopValue = isSticky ? conditionalTopValueInit : headerHeight;
  const conditionalMarginTop = stickyThreshold || isSticky ? 0 : maxHeightSuperbannerWithMargin;

  // Place ad only for desktop layout
  // Logic for displaying container inside AdSlot

  const adUnit = left ? 'Skyscraper_2' : 'Skyscraper';

  const marginLeft = left ? `-${adMaxSkyscraperWidth + defaultSpace}px` : `${desktopContentWidth + defaultSpace}px`;
  return (
    <SCAdSlot
      {...props}
      left={left}
      marginLeft={marginLeft}
      adLayout='desktop'
      adUnit={adUnit}
      sticky={isSticky}
      skipSky={skipSky}
      conditionalTopValue={conditionalTopValue}
      conditionalMarginTop={conditionalMarginTop}
    />
  );
};

export default SkyscraperAdSlot;
